import { render, staticRenderFns } from "./author-select.vue?vue&type=template&id=f17b2a02"
import script from "./author-select.vue?vue&type=script&lang=js"
export * from "./author-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports